import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

    retrieveProducts({ commit }, filter) {
        commit("SET_LOADING", true);
        return getAPI("product/retrieveProducts", filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveProduct({ commit }, product) {
        commit("SET_LOADING", true);
        return postAPI("product/saveProduct", product).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteProduct({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("product/deleteProduct/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },
    
      retrieveProductById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("product/retrieveProductById" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveProductsBySearch({ commit }, request) {
        commit("SET_LOADING", true);
        return getAPI("product/retrieveProductsBySearch" , request)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countProducts({ commit }, filter) {
        commit("SET_LOADING", true);
        return getAPI("product/count", filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };